import React from 'react';
import { Card, List, Tag, Typography, Divider } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import styles from './System.module.scss';

const { Text, Title } = Typography;

const TunedInfo = ({ tunedInfo }) => {
  // tuned 정보 파싱
  const parseTunedInfo = (data) => {
    if (!data || data === 'N/A') return { active: 'N/A', profiles: [] };
    
    try {
      const result = { active: '', profiles: [] };
      const lines = data.trim().split('\n');
      
      lines.forEach(line => {
        if (line.includes('Current active profile:')) {
          result.active = line.replace('Current active profile:', '').trim();
        } else if (line.trim() && !line.includes('Available profiles:')) {
          result.profiles.push(line.trim());
        }
      });
      
      return result;
    } catch (error) {
      console.error('Error parsing tuned info:', error);
      return { active: 'Error', profiles: [] };
    }
  };

  const tunedData = parseTunedInfo(tunedInfo);

  return (
    <Card title="Tuned 프로필 정보" className={styles.systemCard}>
      <div className={styles.tunedContainer}>
        <div className={styles.activeProfile}>
          <Title level={4}>현재 활성 프로필</Title>
          <Tag color="green" icon={<CheckCircleOutlined />} className={styles.activeTag}>
            {tunedData.active}
          </Tag>
        </div>
        
        <Divider />
        
        <div className={styles.availableProfiles}>
          <Title level={4}>사용 가능한 프로필</Title>
          <List
            bordered
            dataSource={tunedData.profiles}
            renderItem={item => (
              <List.Item className={item === tunedData.active ? styles.activeItem : ''}>
                {item === tunedData.active ? (
                  <Text strong>{item} (활성)</Text>
                ) : (
                  <Text>{item}</Text>
                )}
              </List.Item>
            )}
          />
        </div>
      </div>
    </Card>
  );
};

export default TunedInfo;